import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import OfficialHistoryDetailGrid from "../../components/grids/OfficialHistoryDetailGrid";
import { OFFICIAL_HISTORY_ENTITIES, OFFICIAL_HISTORY_ACTIONS } from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class OfficialHistoryPage extends Component {
  componentWillMount() {
    const { auth } = this.props;
    this.props.breadcrumbs([
      { label: "Funkcionáři", path: `${auth.startUrl}/funkcionari` },
      { label: "Historie" },
    ]);
  }

  render() {
    const { auth, params } = this.props;
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={OfficialHistoryDetailGrid}
          gridName="officialHistoryGridV2"
          url={`${auth.startUrl}/api/funkcionari/${params.id}/historie`}
          noteTarget={{ entityType: "Official", entityId: params.id }}
          officialId={params.id}
          showOwner
          showEntity
          showNote
          allowedEntityTypes={OFFICIAL_HISTORY_ENTITIES}
          allowedActions={OFFICIAL_HISTORY_ACTIONS}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(OfficialHistoryPage));
